<template>
  <Moveable
    class="moveable"
    v-bind="moveable"
    ref="moveable"
    @drag="handleDrag"
  >
    <h5 class="handle">Manager</h5>
    <div class="options">
      <label for="stream">Stream:</label>
      <input ref="streamValue" id="stream" type="text" :value="stream" />
      &nbsp;
      <button v-on:click="updateStream">Update</button>
      <br />
      <input id="loggedin" type="checkbox" v-model="loggedIn" />
      <label for="loggedin">Logged in</label>
    </div>
  </Moveable>
</template>

<script>
import Moveable from "vue-moveable";

export default {
  name: "StateUI",
  components: {
    Moveable
  },
  data: () => ({
    moveable: {
      draggable: true
    }
  }),
  computed: {
    loggedIn: {
      get() {
        return this.$store.state.loggedIn;
      },
      set(value) {
        this.$store.commit("logInOut", value);
      }
    },
    stream: {
      get() {
        return this.$store.state.video.stream;
      },
      set(value) {
        this.$store.commit("setStream", value);
      }
    },
  },
  methods: {
    handleDrag({ target, transform }) {
      target.style.transform = transform;
    },
    updateStream() {
      this.stream = this.$refs.streamValue.value;
    }
  },
  mounted() {
    let moveable = this.$refs.moveable.moveable;

    moveable.on("dragStart", event => {
      if (!event.inputEvent.srcElement.classList.contains("handle")) {
        event.stop();
      }
    });
  }
};
</script>

<style lang="stylus">
.moveable
  width: 300px
  height: auto
  background: #FFF
  outline: none
  position: absolute
  right: 30px
  top: 30px
  z-index: 999
  input[type="checkbox"]
    margin-right: 7px
  input[type="text"]
    width: 150px
    margin-left: 7px
  .movable-line
    background: #e5e5e5
  h5
    width: 100%
    margin: 0px
    background: #121844
    color: #FFFFFF
    line-height: 30px
    text-align: center
    font-weight: normal
    cursor: move
  .options
    padding: 15px
    label
      font-size: 12px
.moveable-line
  background: #e5e5e5!important
.content-type-picker
  display: flex
  input[type="radio"], label
    margin-top: 0px
</style>
